<template>
    <vue-scroll :ops="ops">
        <div class="company">
            <HeaderMei></HeaderMei>
            <div class="content">
                <div class="title">
                    美天资质<em>MT Qualification</em>
                    <i></i>
                </div>
                <div class="imgMain clearfix">
                    <div class="items" v-for="(item,index) in imgLists" :key="index">
                        <div class="img" :style="{'height':index>5?'600px':'270px'}">
                            <el-image
                                style="height: 100%"
                                :src="item.src"
                                :preview-src-list="imgLists2">
                            </el-image>
                        </div>
                        <div class="ms">{{item.ms}}</div>
                    </div>
                </div>
            </div>
            <FooterMei></FooterMei>
        </div>
    </vue-scroll>
</template>

<script>
import HeaderMei from '@/components/headerMei';
import FooterMei from '@/components/footerMei';

export default {
    name: 'company',
    components: { HeaderMei, FooterMei },
    data() {
        return {
            ops: {
                rail: {
                    background: '#01a99a',
                    opacity: 0,
                    size: '0px',
                    specifyBorderRadius: false,
                    gutterOfEnds: null,    // 轨道距 x 和 y 轴两端的距离
                    gutterOfSide: '0',   // 距离容器的距离
                    keepShow: false,   // 是否即使 bar 不存在的情况下也保持显示
                    border: 'none'    // 边框
                }
            },
            imgLists: [
                { src: './static/images/1.png', ms: '高新技术产品-农业气象服务平台' },
                { src: './static/images/2.png', ms: '高新技术产品-气象雷达预警' },
                { src: './static/images/3.png', ms: '高新技术产品-气象灾害APP' },
                { src: './static/images/4.png', ms: '高新技术产品-人工影响天气综合指挥平台' },
                { src: './static/images/5.png', ms: '重庆市高新技术企业证书' },
                { src: './static/images/6.png', ms: '重庆市高新技术企业证书' },
                { src: './static/images/7.jpg', ms: 'ISO 9001质量管理体系认证' },
                { src: './static/images/8.png', ms: '信息安全管理体系认证证书' },
                { src: './static/images/9.png', ms: '环境管理体系认证证书' },
            ],
            imgLists2: [
                './static/images/1.png',
                './static/images/2.png',
                './static/images/3.png',
                './static/images/4.png',
                './static/images/5.png',
                './static/images/6.png',
                './static/images/7.jpg',
                './static/images/8.png',
                './static/images/9.png',
            ]
        }
    }
}
</script>

<style scoped lang="less">
    .company {
        width: 100%;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        .content {
            flex: 1;
            padding: 0 20px;
            color: #ffffff;
            .title {
                border-top: 1px solid #ffffff87;
                width: 120px;
                position: relative;
                font-size: 30px;
                /*text-align: center;*/
                height: 70px;
                margin-top: 60px;
                em {
                    font-style: normal;
                    display: block;
                    font-size: 15px;
                }
                i {
                    display: inline-block;
                    width: 60px;
                    height: 1px;
                    background-color: #ffffff87;
                    position: absolute;
                    bottom: 2px;
                    right: -22px;
                }
            }
            .imgMain {
                margin-top: 40px;
                margin-left: -2%;
                .items {
                    width: 31.3333%;
                    margin-left: 2%;
                    float: left;
                    margin-bottom: 20px;
                    .img {
                        border: 1px solid #ffffff87;
                        padding: 10px;
                        min-height: 200px;
                        height: 270px;
                        img {
                            width: 100%;
                        }
                    }
                    .ms {
                        margin-top: 10px;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/company.vue